import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import ToolTip from './ToolTip';
import AnimationScrollPage from '../../../../components/AnimationScrollPage';
import { zipCodeSelector } from '../store/inventory-near-you/selector';
import { MAPPING, trackingEventGeneralClick } from '../helpers';
import { generateImage } from '../../../../utils';
import { colorString, modelId, vinStatus, segmentString, categoryString, familyString, mileRadiusString, dealerString, MODULE_NAME } from '../helpers/constant';
import { CLICK_EVENT_ACTION_TYPE, DEALER_ACTIONS_ACTION_CATEGORY, ZIP_STRING } from '../../../../constants';

const {
  baseMSRP,
  contactDealer,
  mileLabel,
  powerhouseLogo,
  contactDealerPageUrl,
  segment,
  category,
  family,
  searchRange,
} = MAPPING;

const getModelThumbImage = (model) => model.model?.Colors.find((color) => color.MfgColorCd === model.MCCD)?.ModelImage || model.model.ModelImage;
const Model = (props) => {
  const { model, index } = props;
  const zipCode = useSelector(zipCodeSelector);
  const actualMsrp = model
    ?.model
    ?.Colors?.find((y) => y.MfgColorCd === model?.MCCD)
    ?.ActualMsrp;

  const buildLink = contactDealerPageUrl.concat(`?${segmentString}=${segment}&${categoryString}=${category}&${familyString}=${family}`)
    .concat(`&${mileRadiusString}=${searchRange}`)
    .concat(`&${ZIP_STRING}=${zipCode}`)
    .concat(`&${modelId}=${model.model.ModelID}`)
    .concat(`&${dealerString}=${model.DID}`)

    .concat(`&${colorString}=${model.MCCD}`)
    .concat(`&${vinStatus}=${model.VIN[0]?.MVSTT}`);

  const modelImage = getModelThumbImage(model);
  const title = `${model.model?.ModelYear} ${model.model?.ModelName}`;
  let address = `${model.dealer?.DA || ''}`;
  address += model.dealer?.DC ? `. ${model.dealer.DC}` : '';
  address += model.dealer?.DS ? `, ${model.dealer.DS}` : '';

  useEffect(() => {
    new AnimationScrollPage().init();
  }, []);

  return (
    <div className="animation h-full px-2 md:px-4">
      <div className="rounded-4 md:hover:bg-white transition-25 pb-12 md:pb-20">
        <div className={`model anima-bottom delay-${index + 1}`}>
          <div className="pt-1 pb-6 px-18 max-w-370 mx-auto md:py-6p5 md:px-13 md:max-w-none lg:px-10 lg:py-6 2xl:pt-5 2xl:pb-0 2xl:px-16 1k6:py-8p5 1k6:px-18">
            <div className="js-model-thumb category-model-thumb relative pb-[58.8%]">
              <img src={generateImage(modelImage)} alt={title} loading="lazy" className="model-thumb-img object-contain absolute top-0 left-0 w-full h-full object-center lazy-img-hidden transition-25 2xl:ml-6 1k6:ml-0" />
            </div>
          </div>
          <div className="md:px-12">
            <h3 className="text-base mb-4 model-name">{title}</h3>
            <div>
              <ToolTip baseMSRP={baseMSRP} MSRP={actualMsrp} MsrpDisclaimer={`*${model.model.MsrpDisclaimer}`} destinationChargePrice={model.model.DestinationCharge} />
              <div className="flex items-center mb-4">
                {model.dealer?.DPH && <img src={generateImage(powerhouseLogo)} className="w-16 mr-6" alt={model.dealer?.DN} />}
                <div className="content">
                  <h3 className="text-xl mb-0 -mt-2">{model.dealer?.DN}</h3>
                  <p className="text-sm mb-0"> {parseFloat(model.dealer?.DD)}&nbsp;{mileLabel}</p>
                </div>
              </div>
              <address className="mb-0 not-italic">
                <a
                  className="text-inherit no-underline hover:underline"
                  onClick={trackingEventGeneralClick.bind(this, `${MODULE_NAME}:get directions`, model.dealer, model.dealer?.DDIR)}
                  href={model.dealer?.DDIR}
                  target="_blank"
                  rel="noreferrer nofollow"
                  data-event-type={CLICK_EVENT_ACTION_TYPE}
                  data-event-module={MODULE_NAME}
                  data-event-label="get directions"
                  data-event-category={DEALER_ACTIONS_ACTION_CATEGORY}
                >
                  <span>
                    {address}
                  </span>
                  <br />
                  {model.dealer?.DZ &&
                    <span>{model.dealer.DZ}</span>
                  }
                </a>
              </address>
              <p className="mb-13">
                <a className="text-black underline-offset-2" onClick={trackingEventGeneralClick.bind(this, `${MODULE_NAME}:call dealer`, model.dealer, `tel:${model.dealer?.DP}`)} href={`tel:${model.dealer?.DP}`}>
                  {model.dealer?.DP}
                </a>
              </p>
              <p className="mb-0">
                <a
                  href={`${buildLink}`}
                  onClick={trackingEventGeneralClick.bind(this, `${MODULE_NAME}:${contactDealer}`, model.dealer, buildLink)}
                  className="btn btn-text btn-text-primary text-underline m-0"
                  data-event-type={CLICK_EVENT_ACTION_TYPE}
                  data-event-module={MODULE_NAME}
                  data-event-label={contactDealer}
                  data-event-category={DEALER_ACTIONS_ACTION_CATEGORY}
                >
                  <span>{contactDealer}</span>
                  <span className="sr-only">{model.dealer?.DN} for {title}, {colorString} {model.MCCD}</span>
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Model;